module.exports = __webpack_public_path__ + "img/Chef_MunchiesLabs.a3bc257f.jpeg";